import { render, staticRenderFns } from "./RepairInfo.vue?vue&type=template&id=15c3d37c&scoped=true"
import script from "./RepairInfo.vue?vue&type=script&lang=js"
export * from "./RepairInfo.vue?vue&type=script&lang=js"
import style0 from "./RepairInfo.vue?vue&type=style&index=0&id=15c3d37c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3d37c",
  null
  
)

export default component.exports